import JSDB from '../../fromKotlin/nk';

const API_BASE = 'https://nihulkav.online:4000';

function getHeaders(): HeadersInit {
    const token = (JSDB() as any).getToken?.();
    return {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
    };
}

function getCompanyId(): string {
    try {
        const db = JSDB() as any;
        if (typeof db.getCompanyId === 'function') return String(db.getCompanyId());
        return '';
    } catch {
        return '';
    }
}

export async function fetchHubWidgetTicket(channelAccountId?: string): Promise<{
    ticket: string;
    embed_url: string;
    expires_at?: string;
}> {
    const companyId = getCompanyId();
    if (!companyId) throw new Error('חסר מזהה חברה');
    const db = JSDB() as any;
    const res = await fetch(`${API_BASE}/whatsapp/hub_widget_ticket`, {
        method: 'POST',
        headers: getHeaders(),
        body: JSON.stringify({
            company_id: companyId,
            channel_account_id: channelAccountId || '',
            company_name: String(db.getCompany?.() || ''),
            agent_name: String(db.currentAgent || ''),
        }),
    });
    const json = await res.json().catch(() => null);
    if (!res.ok || json?.status !== 'SUCCESS' || !json?.data?.embed_url) {
        throw new Error(json?.status_msg || 'לא ניתן לפתוח את תיבת השיחות');
    }
    return json.data;
}
